import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { Form, Row, Col, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotateRight } from "@fortawesome/free-solid-svg-icons";

const DateRangePicker = ({ getFilteredDate }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleStartDateChange = (date) => {
    setStartDate(date);
    if (endDate && date > endDate) {
      setEndDate(null); // Reset end date if start date is after end date
    }
  };

  const handleEndDateChange = (date) => {
    if (!startDate || date >= startDate) {
      setEndDate(date);
    }

    if (startDate && endDate && startDate > endDate) {
      Swal.fire({
        icon: "error",
        title: "Invalid Date Range",
        text: "The start date cannot be later than the end date.",
      });
    }
  };

  return (
    <Form>
      <Row>
        <Col
          xs={6}
          className="d-flex justify-content-around"
        >
          <DatePicker
            selected={startDate}
            onChange={handleStartDateChange}
            className="form-control"
            placeholderText="Start date"
          />
          <DatePicker
            selected={endDate}
            onChange={handleEndDateChange}
            className="form-control"
            placeholderText="End date"
            minDate={startDate} // Prevent selecting a date before the start date
          />
          <Button
            onClick={() =>
              getFilteredDate(
                startDate?.toLocaleDateString(),
                endDate?.toLocaleDateString()
              )
            }
            disabled={!startDate || !endDate}
          >
            Submit
          </Button>
          <Button onClick={() => window.location.reload()}>
            <FontAwesomeIcon icon={faRotateRight} />
          </Button>
        </Col>
        <Col xs={6}>
        </Col>
      </Row>
    </Form>
  );
};

export default DateRangePicker;
